import { Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite } from '.';
import ActiviteEntenteProduit from './activite-entente-produit.entity';
import { PionNombreLog } from './pion-nombre-log.entity';

export enum TypeNombre {
    Reservé = 'reserve',
    Confirmé = 'confirme',
    Réel = 'reel',
    Facturable = 'facturable',
}

@Entity('nombre_log')
export class NombreLog implements BaseEntite {
    @PrimaryGeneratedColumn()
    id: number;

    @Column()
    name: TypeNombre;

    @Column()
    fk_id_activite_entente_produit: number;

    @ManyToOne(() => ActiviteEntenteProduit)
    @JoinColumn({ name: 'fk_id_activite_entente_produit', referencedColumnName: 'id' })
    activiteEntenteProduit: ActiviteEntenteProduit;

    @Column()
    nombre: number;

    @Column()
    date_creation: string;

    @Column({ type: 'text' })
    notes: string;

    @OneToMany(() => PionNombreLog, (pion: PionNombreLog) => pion.nombreLog, { cascade: true })
    pions: PionNombreLog[];
}
